/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Premium_TitleInputs */

const en_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Users Subscription Note`)
};

const ar_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظة اشتراك المستخدمين المحترفين`)
};

const de_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Users Abonnement Hinweis`)
};

const es_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota de suscripción para usuarios Pro`)
};

const fr_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note sur l'abonnement pour les utilisateurs Pro`)
};

const it_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota sull'abbonamento per gli utenti Pro`)
};

const ja_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロ版ユーザー向けサブスクリプションに関する注意事項`)
};

const ko_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro 사용자 구독 참고 사항`)
};

const pt_br_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observação sobre a assinatura para usuários Pro`)
};

const ru_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечание о подписке для пользователей Pro-версии`)
};

const th_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หมายเหตุการสมัครสมาชิกสำหรับผู้ใช้เวอร์ชันโปร`)
};

const tr_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Kullanıcıları Abonelik Notu`)
};

const zh_cn_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业版用户说明`)
};

const zh_tw_subscription_detail_premium_title = /** @type {(inputs: Subscription_Detail_Premium_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專業版用戶訂閱說明`)
};

/**
* | output |
* | --- |
* | "Pro Users Subscription Note" |
*
* @param {Subscription_Detail_Premium_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_premium_title = /** @type {((inputs?: Subscription_Detail_Premium_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Premium_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_premium_title(inputs)
	if (locale === "ar") return ar_subscription_detail_premium_title(inputs)
	if (locale === "de") return de_subscription_detail_premium_title(inputs)
	if (locale === "es") return es_subscription_detail_premium_title(inputs)
	if (locale === "fr") return fr_subscription_detail_premium_title(inputs)
	if (locale === "it") return it_subscription_detail_premium_title(inputs)
	if (locale === "ja") return ja_subscription_detail_premium_title(inputs)
	if (locale === "ko") return ko_subscription_detail_premium_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_premium_title(inputs)
	if (locale === "ru") return ru_subscription_detail_premium_title(inputs)
	if (locale === "th") return th_subscription_detail_premium_title(inputs)
	if (locale === "tr") return tr_subscription_detail_premium_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_premium_title(inputs)
	return zh_tw_subscription_detail_premium_title(inputs)
});